<template>
  <div class="panel granary-right-panel">
    <right-card :bg="'border-new'">
      <!-- <g-title :bg="'cyfb'">各区城镇/农村人均可支配收入对比</g-title> -->
      <div class="content">
        <div class="chart-box">
          <!-- <div class="tab-box flex">
            <div
              v-for="(item, index) in typeList"
              :key="index"
              class="tab-item"
              :class="{ active: active === index }"
              @click="changeType(index, item)"
            >
              <span>{{ item }}</span>
            </div>
          </div> -->
          <div ref="chart" class="chart"></div>
        </div>
      </div>
    </right-card>
  </div>
</template>

<script>
// import gTitle from "../../components/gTitle";
import { loadChart } from "./charts/rjsrData";
// import { getDpPagePanel } from "@/api/granary";
import { get } from "@/api/index";
import { findIndexByName } from "@/util/index";
export default {
  // components: { gTitle },
  data() {
    return {
      typeList: ["城镇", "农村"],
      active: 0,
      selectName: "总产值"
    };
  },
  mounted() {
    this.chart = this.$echarts.init(this.$refs.chart);
    this.getData();
  },
  methods: {
    changeType(index, name) {
      this.active = index;
      this.selectName = name;
      this.getData();
    },
    getData() {
      /**
       * name: '城镇居民人均可支配收入',
       * data: [
       * {
       *  year: 2015,
       *  value: 102
       * }
       * ]
       */
      get("/api/dp/visual/queryList", { code: "jmrjkzpsr" }).then(res => {
        const { item, data } = res;
        let keyname = "year";
        let valname = "sr_value";
        const index = findIndexByName("值", item, "name");
        if (~index) {
          valname = item[index].code;
        }
        let xdata = [];
        data.forEach(e => {
          const i = findIndexByName(e.series, xdata, "name");
          if (~i) {
            xdata[i].data.push({
              name: e[keyname],
              value: e[valname]
            });
          } else {
            xdata.push({
              name: e.series,
              data: [
                {
                  name: e[keyname],
                  value: e[valname]
                }
              ]
            });
          }
          // console.log("xdata ==", xdata);
          if (xdata.length > 0) {
            loadChart(
              this.chart,
              xdata.map(e => e.data.map(e1 => e1.value)),
              xdata.map(e => e.name),
              xdata[0].data.map(e => e.name)
            );
          }
        });
      });
      //  静态数据
      // let xData = [
      //   "城镇居民人均可支配收入",
      //   "农村居民人均可支配收入",
      //   "城乡居民人均可支配收入比"
      // ];
      // let yearList = ["2015", "2016", "2017", "2018", "2019", "2020"];
      // let yData = [
      //   [21396.8, 23322.56, 25315.41, 27163.43, 29405.0, 30733],
      //   [13224, 14519.9, 15695.2, 16950.8, 18482, 19621.2],
      //   [1.681, 1.606, 1.613, 1.602, 1.591, 1.57]
      // ];
      // loadChart(this.chart, yData, xData, yearList);
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'

.panel
  height 100%
  font-size .06rem
  overflow hidden

.content
  height 100%
  text-align center
  position relative

.chart-box
  width 100%
  height 100%
  position relative
  .tab-box
    position absolute
    top 15px
    right 3%
    z-index 999
    .tab-item
      color #fff
      font-size 10px
      padding-left 16px
      margin-right 20px
      position relative
      cursor pointer
      &:before
        content ' '
        // width 6px
        // height 6px
        width 12px
        height 12px
        border-radius 50%
        background #fff
        position absolute
        left 0
        top 50%
        transform translateY(-50%)
    .active
      color #0e9cff
      &:before
        background #0e9cff
  .chart
    width 100%
    height 100%
</style>
